export const FacebookLogo = () => (
  <a
    href="https://www.facebook.com/prenuvo"
    aria-label="click this link to go to Prenuvo's facebook page"
    aria-current="page"
    className="transition ease-in-out hover:opacity-70"
    rel="noopener noreferrer"
  >
    <svg
      aria-label="facebook link to Prenuvo's page opens in same tab"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <path
        d="M22 12.0611C22 6.50451 17.5229 2 12 2C6.47715 2 2 6.50451 2 12.0611C2 17.0828 5.65684 21.2452 10.4375 22V14.9694H7.89844V12.0611H10.4375V9.84452C10.4375 7.32296 11.9305 5.93012 14.2146 5.93012C15.3088 5.93012 16.4531 6.12663 16.4531 6.12663V8.60261H15.1922C13.95 8.60261 13.5625 9.37822 13.5625 10.1739V12.0611H16.3359L15.8926 14.9694H13.5625V22C18.3432 21.2452 22 17.083 22 12.0611Z"
        fill="CurrentColor"
      ></path>
    </svg>
  </a>
);
